/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils


/* ++++++++++ --------------- EXPORT : COMMUNITY SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  communitysection: {
    marginTop: pxToEm(16),
    '& .collapsable.opened': {
      maxHeight: pxToEm(3000)
    }
  }
});
